import { render, staticRenderFns } from "./SiteList.vue?vue&type=template&id=6dbc80b0&scoped=true"
import script from "./SiteList.vue?vue&type=script&lang=js"
export * from "./SiteList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dbc80b0",
  null
  
)

export default component.exports